import styled from "styled-components";
import { LinearProgress } from "@mui/material";

// Styling for the base progress bar
export const ProgressBarStyled = styled.div`
width: 100%;
  .labels {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .start {
    display: flex;
    justify-content: start;
  }
  .middle {
    display: flex;
    justify-content: center;
  }

  .end {
    display: flex;
    justify-content: end;
  }

  .description {
    margin-left: 8px;
  }

  .actual-value {
    margin-top: 8px;
    color: red;
    font-weight: bold;
  }

  .red-progress {
    .css-10qhckt-MuiLinearProgress-root {
      background-color: transparent !important;
    }
  }
`;

// Styling for the over-budget progress bar
export const LinearProgressStyled = styled(LinearProgress)`
  .MuiLinearProgress-bar {
    background-color: #4bb543 !important;
  }
  .MuiLinearProgress-root {
    background-color: #301d35; // Background color for the base bar
  }

  .css-10qhckt-MuiLinearProgress-root {
    background-color: #301d35 !important;
  }
`;

// Styling for the over-budget progress bar
export const OverBudgetProgress = styled(LinearProgress)`
  .MuiLinearProgress-bar {
    background-color: red !important; // Red color for the over-budget part
  }
  .MuiLinearProgress-root {
    background-color: transparent !important; // Transparent background for the over-budget bar
  }

  .css-10qhckt-MuiLinearProgress-root {
    background-color: transparent !important;
  }
`;
